var map = {
	"./classic.svg": "f27b",
	"./comfort.svg": "633e",
	"./confort.svg": "53ae",
	"./elite.svg": "07d2",
	"./essential.svg": "e3ff",
	"./platinum.png": "8b6f",
	"./premium.svg": "7a2f",
	"./standard.svg": "0ea5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d977";